import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { English, Spanish } from '../../Constant';
import { LI, UL } from '../../AbstractElements';

const Language = () => {
  const [selected, setSelected] = useState('en');
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelected(lng);
  };

  return (
    <Fragment>
      <div className="language-dropdown onhover-show-div">
        <UL attrUL={{ className: 'simple-list p-3' }}>
          <LI
            attrLI={{
              onClick: () => changeLanguage('en'),
              style: { cursor: 'pointer' },
            }}
          >
            <i className="flag-icon flag-icon-is" /> {English}
          </LI>
          <LI
            attrLI={{
              onClick: () => changeLanguage('es'),
              style: { cursor: 'pointer' },
            }}
          >
            <i className="flag-icon flag-icon-np" /> {'नेपाली'}
          </LI>
        </UL>
      </div>
    </Fragment>
  );
};

export default Language;
